import StorageHelp from '@/utils/storageHelp'
import {getSysMenu} from '@/api/archiveManage/user'


let currentMenuList = StorageHelp.getStorage(StorageHelp.userMenu || '[]');
export const archiveMenuConfig = {
  namespaced: true,
  state:{
    menuEnum: {
      visitorRegisterFeeManage: currentMenuList ? currentMenuList.visitorRegisterFeeManage : false,   //  来访登记
      treatmentTaskByRealTime: currentMenuList ? currentMenuList.treatmentTaskByRealTime : false,    // 实时消费登记
      treatmentTaskToOldpeople: currentMenuList ? currentMenuList.treatmentTaskToOldpeople : false,   //  定制服务
      oldPeopleHealthyInfo: currentMenuList ? currentMenuList.oldPeopleHealthyInfo : false,       //  长者健康
      wardRoundArchive: currentMenuList ? currentMenuList.wardRoundArchive : false,            // 查房
      archiveDataAnalysis: currentMenuList ? currentMenuList.archiveDataAnalysis : false,// 院长驾驶舱
      regionalManagement: currentMenuList ? currentMenuList.regionalManagement : false, // 区域管理
      distributeDisplay: currentMenuList ? currentMenuList.distributeDisplay : false, // 区域房态图
      myNursingTask: currentMenuList ? currentMenuList.myNursingTask : false, // 我的护理任务
      feedback: currentMenuList ? currentMenuList.feedback : false, // 反馈单管理
      oldpeopleConcernExamine: currentMenuList ? currentMenuList.oldpeopleConcernExamine : false, // 长者关注申请管理
      homeElderServiceRecord: currentMenuList ? currentMenuList.homeElderServiceRecord : false, // 居家管理
      endowmentCircleManage: currentMenuList ? currentMenuList.endowmentCircleManage : false, // 养老圈
      homeSite: currentMenuList ? currentMenuList.homeSite : false, // 居家场所管理
      organizationDataAnalysis: currentMenuList ? currentMenuList.organizationDataAnalysis : false, // 机构平台驾驶舱
      waterMeterElectricityRecord: currentMenuList ? currentMenuList.waterMeterElectricityRecord : false, // 水电桶装水登记
      waterWorkList: currentMenuList ? currentMenuList.waterWorkList : false, // 桶装水任务单
    }
  },
  mutations: {
    removeCurrentMenuList(state) {
      state.currentMenuList = [];
      StorageHelp.clearStorage(StorageHelp.userMenu);
      this.commit('archiveMenuConfig/initMenuChunk')
    },
    setCurrentMenuList(state, currentMenuList) {
      state.currentMenuList = currentMenuList;
      StorageHelp.setStorage(StorageHelp.userMenu, currentMenuList);
    },

    // 初始化展示菜单
    initMenuChunk(state) {
      for (let key in state.menuEnum) {
        state.menuEnum[key] = false;
      }
      StorageHelp.setStorage(StorageHelp.menuEnum, state.menuEnum);
    },
    // 设置菜单
    setMenuChunk(state, key) {
      state.menuEnum[key] = true;
      StorageHelp.setStorage(StorageHelp.menuEnum, state.menuEnum);
    }
  },

  actions: {
    getCurrentMenuList({commit, state}) {
      return new Promise((resolve, reject) => {
        getSysMenu().then(resp => {
          let arr = [];
          console.log(resp,'resp');
          (resp || []).forEach((fVal, fIndex) => {
            if (fVal.children && fVal.children.length > 0) {
              fVal.children.forEach((sVal, sIndex) => {
                arr.push(sVal);
                for (let key in state.menuEnum) {
                  if (sVal.component === key) {
                    commit('setMenuChunk', key);
                    break;
                  }
                }
              })
            }
          });
          this.commit("archiveMenuConfig/setCurrentMenuList", arr);
          resolve(resp)
        })
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/archiveMenuConfig.js